import React from "react";

/**
 * Phase 11 — brand logo with size- and theme-aware variants.
 *
 * Variants (file, served from /public/assets/brand):
 *  - logo-primary.png        — emblem + "LIFESPAN WEALTH PARTNERS" wordmark, no tagline
 *  - logo-compact.png        — emblem + "LIFESPAN" only (mobile header)
 *  - logo-white-primary.png  — primary on navy background (footer / dark overlays)
 *  - logo-emblem.png         — square emblem (favicon fallback / loader)
 *
 * Rendering rules:
 *  - Desktop (≥ md): primary variant, max-height 56px
 *  - Mobile (< md):  compact variant, max-height 44px
 *  - When variant="light", force white variant regardless of breakpoint
 *  - When variant="emblem", force the square emblem
 */
export const Logo = ({ variant = "navy", className = "" }) => {
  if (variant === "emblem") {
    return (
      <a
        href="/"
        data-testid="brand-logo"
        aria-label="Lifespan Wealth Partners — home"
        className="inline-flex items-center"
      >
        <img
          src="/assets/brand/logo-emblem.png"
          alt="Lifespan Wealth Partners"
          className={`h-10 w-10 object-contain ${className}`}
        />
      </a>
    );
  }

  if (variant === "light") {
    return (
      <a
        href="/"
        data-testid="brand-logo"
        aria-label="Lifespan Wealth Partners — home"
        className="inline-flex items-center group"
      >
        <img
          src="/assets/brand/logo-white-primary.png"
          alt="Lifespan Wealth Partners"
          className={`h-12 sm:h-14 w-auto transition-transform duration-500 group-hover:scale-[1.02] ${className}`}
          style={{ display: "block" }}
        />
      </a>
    );
  }

  // Default navy variant — responsive swap between compact (mobile) and primary (desktop)
  return (
    <a
      href="/"
      data-testid="brand-logo"
      aria-label="Lifespan Wealth Partners — home"
      className="inline-flex items-center group"
    >
      <picture>
        {/* Desktop — primary logo, large & readable */}
        <source
          media="(min-width: 768px)"
          srcSet="/assets/brand/logo-primary.png"
        />
        {/* Mobile — compact "LIFESPAN" logo */}
        <img
          src="/assets/brand/logo-compact.png"
          alt="Lifespan Wealth Partners"
          className={`h-13 md:h-14 w-auto transition-transform duration-500 group-hover:scale-[1.02] ${className}`}
          style={{ display: "block", maxHeight: "52px" }}
        />
      </picture>
    </a>
  );
};

export default Logo;
